import {BrickContext, ActionBrick, registerBrick, Transaction} from 'olympe';
import DGJournalEntry from "./DGJournalEntry";
import {getLogger} from "@olympeio/core";

export default class MapToObjects extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Array} jsonData
     * @param {function()} forwardEvent
     * @param {function(Array)} setObjList
     */
    async update($, [jsonData], [forwardEvent, setObjList]) {

        getLogger('MapToObjects').info('Data', jsonData);
        const t = new Transaction();
        jsonData?.forEach(data => {
            const properties = new Map()
                    .set(DGJournalEntry.memoProp, data.Memo)
                    .set(DGJournalEntry.referenceProp, data.Reference)
                    .set(DGJournalEntry.reference2Prop, data.Reference2)
                    .set(DGJournalEntry.referenceDateProp, new Date(data.ReferenceDate))
                    .set(DGJournalEntry.amountProp, data.JournalEntryLines.reduce((acc, cur) => acc+cur.DebitSys, 0))
                    .set(DGJournalEntry.statusProp, (data.U_Conso_Result === 1 ? 'success' : (data.U_Conso_Result === 2 ? 'error' : 'not sync')))
                    .set(DGJournalEntry.syncDateProp, new Date(data.U_Conso_Date))
                    .set(DGJournalEntry.errorProp, data.U_Conso_Err)
                    .set(DGJournalEntry.JdtNumProp, data.JdtNum);
            t.create(DGJournalEntry, properties);
        });

        const result = await t.execute();
        setObjList(result.getCreatedObjects())
        forwardEvent();
    }
}

registerBrick('01917f9d7ae4c79469bb', MapToObjects);
